module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAVFJREFUWAnt1T0OgjAUB3CrE/EWnoHBRRdZvYZxZdMT6MZqPAKOrro5MOhxjDGSYP9FGpEqpR/q0A5Iv9775Qm01XLNVcBVwFXAVcBVwFXAVeB3FYjjuPPt7K85SQGYTiYzeh943e44iqJLMW7zNwxD73I+b2mO3Wq9XiIXqwjDZNmC9nvp7dYfDIebJElSLLDVOCbLRjRH4Pv+9Xg6HdqVhHQB1NhQmTM08IIpRWUVggxCOhM8Zq1VSoghZF76y4D4BqoOA0fprbKJksFUQBiwgZLFCEGmUU0wb0GmUE0xH0G6KBVMLUgVpYqRAjVF6WCkQbIoXQzy8MMVHZn2dO7lywnZ40BGhx2U+dlUzPEvcD5Qf20MQkgRiqXSxCBG6UvNgkpcRB9Puq3Htz6dTXxM8kYJhNgCVJ5SA4MAyiBsrqA0MYhppOGZYs+VkWh/FuQOf15RZOihNn0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/line_items_details_arrow_down.png
// module id = 1543
// module chunks = 0